import React from 'react';
import './starting-point-modal.styles.scss';
import Modal from '@/components/modal/modal.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket } from '@fortawesome/free-solid-svg-icons';
import { faCopy, faObjectUngroup } from '@fortawesome/free-regular-svg-icons';
import { useNavigate } from 'react-router-dom';

const StartingPointModal = ({
    show,
    cancel,
}) => {

    // const [ req ] = useState([]);
    const navigate = useNavigate();

    function handleNavigate(path) {
        navigate(path);
        cancel();
    }

    return (
        <Modal
            show={show}
            cancel={cancel}
            text='How do you want to start creating this game?'
            cls='narrow'
            closeButton={true} >
            <div className='starting-point-modal'>
                <div className='button-container'>
                    <button 
                        className='g-button'
                        onClick={() => handleNavigate('/home/creategame')}>
                        <FontAwesomeIcon icon={faRocket} />
                        Start From Scratch
                    </button>
                    <button
                        className='g-button'
                        onClick={() => handleNavigate('copy')}>
                        <FontAwesomeIcon icon={faCopy} />
                        Copy An Existing Game
                    </button>
                    <button
                        className='g-button'
                        onClick={() => handleNavigate('fromtemplate')}>
                        <FontAwesomeIcon icon={faObjectUngroup} />
                        Start With a Template
                    </button>
                    
                    <div></div>
                </div>
            </div>
        </Modal>
    )
}

export default StartingPointModal